export default {
  zh: {
    signOut: '退 出',
    backend: '管理后台',
    myAccount: '个人中心'
  },
  en: {
    signOut: 'Sign Out',
    backend: 'Backend',
    myAccount: 'My Account'
  }
}



// WEBPACK FOOTER //
// ./src/components/plexHeader/mainHeader/accountInfo/lang.js